<script lang="tsx" setup>
import useDataAssetColumns from './columns'
import FilterContainer from '../filter/FilterContainer.vue'
import TextFilter from '../filter/TextFilter.vue'
import SingleSelectFilter from '../filter/SingleSelectFilter.vue'
import { selectItem, TextField, ValueField } from '@/models/select-item'
import InstanceFilter from '../filter/InstanceFilter.vue'
import ResponsibleFilter from '../filter/ResponsibleFilter.vue'
import { onBeforeMount } from 'vue'
import CalendarFilter from '../filter/CalendarFilter.vue'

const props = defineProps<{
	component: string
}>()

const { columns, custom, all } = useDataAssetColumns(props.component)
const isKeyOfColumns = (key: string): key is keyof typeof columns => key in columns

const setFilterFromParams = () => {
	const params = new URLSearchParams(window.location.search)
	for (const [key, value] of params) {
		// Key doesn't exist in columns or not a filter param.
		if (!isKeyOfColumns(key)) {
			continue
		}
		const column = columns[key].value
		if (key === 'responsible') {
			const parsed = JSON.parse(value)
			column.filter = [{ id: parsed.id, type: parsed.type }]
		} else if (key === 'name') {
			column.filter = value
		} else {
			const parsedNumber = parseInt(value)
			if (!isNaN(parsedNumber)) {
				column.filter.push(parsedNumber)
			} else {
				column.filter.push(value)
			}
		}
	}
}

onBeforeMount(() => {
	setFilterFromParams()
})
</script>

<template>
	<FilterContainer :columns="all" :custom="custom" bookmark="data-assets-bookmark">
		<div class="p-2 filter-col" v-if="columns.name.value.isVisible">
			<TextFilter data-test="name-filter-data-asset" v-model="columns.name.value"></TextFilter>
		</div>

		<div class="p-2 filter-col" v-show="columns.instance.value.isVisible">
			<InstanceFilter data-test="instance-filter-data-asset" v-model="columns.instance.value"></InstanceFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.responsible.value.isVisible">
			<ResponsibleFilter data-test="owner-filter-data-asset" v-model="columns.responsible.value"></ResponsibleFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.date.value.isVisible">
			<CalendarFilter data-test="date-filter-data-asset" v-model="columns.date.value"></CalendarFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.hasPersonalData.value.isVisible">
			<SingleSelectFilter
				data-test="personal-data-filter-data-asset"
				:label-field="TextField"
				:value-field="ValueField"
				:options="[selectItem('misc.yes', 1), selectItem('misc.no', 0)]"
				v-model="columns.hasPersonalData.value"
			></SingleSelectFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.location.value.isVisible">
			<TextFilter data-test="location-filter-data-asset" v-model="columns.location.value"></TextFilter>
		</div>
	</FilterContainer>
</template>
